import { api } from 'app/config/apiConfig';
import { CreditNote } from 'entities/CreditNote';
import { CreditAndRefundPaymentParams } from '../model/types';

export const creditAndRefundPaymentApi = api.injectEndpoints({
  endpoints: (build) => ({
    creditAndRefundPayment: build.mutation<CreditNote, CreditAndRefundPaymentParams>({
      query: (data) => ({
        url: `/billing-documents/payments/${data.paymentId}/refund`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Invoices', 'Deposit Payment', 'My bookings', 'Contract details', 'Deposit History'],
    }),
  }),
});

export const { useCreditAndRefundPaymentMutation } = creditAndRefundPaymentApi;
